import { setBaseUrl, getAxios } from "@repo/rq-api-public";

setBaseUrl(import.meta.env.VITE_API_HOST);

const axios = getAxios();

function getApiKeyFromQuery() {
  try {
    if (typeof window === "undefined") {
      return null;
    }

    const params = new URLSearchParams(window.location.search);
    const apiKey = params.get("platformKey");

    return apiKey;
  } catch (e) {
    return null;
  }
}

// Add a request interceptor to add the api key token to the ApiKey header.
axios.interceptors.request.use(
  (config) => {
    const apiKeyFromQuery = getApiKeyFromQuery();
    const apiKey = apiKeyFromQuery ?? import.meta.env.VITE_API_KEY;

    if (!apiKeyFromQuery) {
      // Log a warning if the API key is not found in the query string
      console.warn(
        "API key not found in query string, falling back to VITE_API_KEY."
      );
    }

    config.headers.ApiKey = apiKey;

    return config;
  },
  (error) => Promise.reject(error)
);
